
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[id]/follower",
      function () {
        return require("private-next-pages/user/[id]/follower.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[id]/follower"])
      });
    }
  